<template>
  <tbody class="thead">
    <tr>
      <th v-if="tableIsTeam">
        <template v-if="reportQuery.group_by === 'policy'"> Member </template>
        <template v-else-if="reportQuery.group_by === 'member'"> Policy </template>
      </th>
      <th>Used</th>
      <th>Pending</th>
      <th>Balance</th>
      <th>Reason</th>
    </tr>
  </tbody>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'TimeOffBalancesReportTableHeader',
  computed: {
    ...mapGetters(['reportQuery', 'tableIsTeam']),
  },
};
</script>
